import { render, staticRenderFns } from "./tba-terms-conditions.vue?vue&type=template&id=762013a4&"
import script from "./tba-terms-conditions.vue?vue&type=script&lang=js&"
export * from "./tba-terms-conditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports